import React from 'react'
import { useGetUserPicQuery } from "@/features/users/usersApiSlice"
// import UserPicUploadForm from '@/components/common/UserPicUploadForm'
import { userProfileIcon2 } from "@/assets/img/imgAssets"
import EtUserPicUploadForm from './EtUserPicUploadForm'

const EtUserPicUploadInline = () => {

  // First Created - 06 May 2025
  // Author - Atul Pandey


  return (
    <div className="p-2">
      {/* <h2 className="text-lg font-semibold text-gray-700 mb-2">Upload Profile Picture</h2> */}
      <EtUserPicUploadForm />
    </div>
  )
}

export default EtUserPicUploadInline